export default __webpack_public_path__ + "static/media/budgetapp.7ae94a17.png";